export interface OAuthClaimFragment {
  claimToken: string | null;
  cleanHash: string;
}

/**
 * Read and remove a post-callback claim from a URL fragment. Fragments are not
 * sent in HTTP requests or referrers, so only the browser that finishes the
 * provider login receives this token. The caller must replace the URL before
 * its first API request.
 */
export function readOAuthClaimFragment(input: {
  hash: string;
  statusKey: string;
  tokenKey: string;
}): OAuthClaimFragment | null {
  const params = new URLSearchParams(input.hash.replace(/^#/, ""));
  if (params.get(input.statusKey) !== "claim") return null;

  const rawToken = params.get(input.tokenKey) ?? "";
  const claimToken = /^[A-Za-z0-9_-]{32,128}$/.test(rawToken) ? rawToken : null;
  params.delete(input.statusKey);
  params.delete(input.tokenKey);
  const clean = params.toString();
  return { claimToken, cleanHash: clean ? `#${clean}` : "" };
}
